export const apiUrl = {
  framework_list: "api/v1/frameworks",
  create_project: "api/v1/projects",
  list_projects: "api/v1/projects/organizations",
  add_evidence: "api/v1/evidence",
  add_evaluations: "api/v1/evaluations",
  evidence_details: "api/v1/evidence/project_controls",
  evaluation_details: "api/v1/evaluations",
  project_report: "api/v1/reports/projects",
  dashboard_report: "api/v1/reports",
  arc_ai_chat: "api",

  // projects
  list_of_project: "api/v1/projects/get-project-list",
}